// Port of api/fuel/app/classes/controller/api/monty/config.php
import DB from 'offline/db'
export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id')
	var config = {}
	if (userId) {
		var rows = DB.query('SELECT config_data FROM config WHERE user_id = ?', [userId])
		if (rows.length && rows[0].config_data) {
			try {
				config = JSON.parse(rows[0].config_data)
			} catch (e) {
				config = {}
			}
		}
	}
	return Promise.resolve({ session: { offline: true }, data: { config: config } })
}
